/**
 * This rule transforms  the field AdditionalCTA into teaser targets since AdditionalCTA its not supported by coremedia anymore
 */
const AdditionalCTARule = ({ item }) => {
  if (item?.additionalCTA?.length > 0) {
    const transformedTargets = item.additionalCTA.map((singleItem) => ({
      target: {
        type: 'externalLink',
        href: singleItem.link,
        teaserTitle: singleItem.text
      }
    }))

    return {
      item: {
        ...item,
        target: item?.target || {
          type: 'externalLink',
          href: item.additionalCTA[0].link,
          teaserTitle: item.additionalCTA[0].text
        },
        targets: item?.targets ? [...item.targets, ...transformedTargets] : [...transformedTargets]
      }
    }
  }

  return { item }
}

export default AdditionalCTARule